/**
 * `maxItems` counts the whole array, and the `prefixItems` entries fill it from the front.
 * An `items` member can only be built in what is left over.
 */
export function itemsFitWithinMaxItems(input, _, context) {
    const array = input;
    const offersChoice = Boolean(array?.items?.oneOf?.length || array?.items?.anyOf?.length);
    const positions = array?.prefixItems?.length ?? 0;
    if (!offersChoice || array.maxItems === undefined || array.maxItems > positions) {
        return [];
    }
    return [{
            message: `maxItems is ${array.maxItems} and ${positions} prefixItems entries already fill it, so no items member can ever be built. Raise maxItems or remove items.`,
            path: [...context.path],
        }];
}
//# sourceMappingURL=items-fit-within-max-items.js.map